import PropTypes from "prop-types";
import React, { useContext } from "react";

import { AuthContext, useUserInfo } from "@swa-ui/authentication";
import { getBootstrapData } from "@swa-ui/bootstrap";
import { useDeviceInfo } from "@swa-ui/browser";
import { HorizontalList } from "@swa-ui/core";
import { Currency } from "@swa-ui/currency";
import i18n from "@swa-ui/locale";
import { classNames, convertToTitleCase } from "@swa-ui/string";

import styles from "./CtmInformation.module.scss";

/**
 * CtmInformation provides the CTM's account info for the header.
 */

export const CtmInformation = (props) => {
  const { light } = props;
  const { getCtmInfo } = useUserInfo();
  const { handleLogout } = useContext(AuthContext);
  const { isLargeOrXlarge } = useDeviceInfo();
  const { CORPORATE__TRAVEL_MANAGER_ACCOUNT_MANAGEMENT } = getBootstrapData("urls");
  const ctmInfo = getCtmInfo();
  const { corporateUserInformation, companyInformation } = ctmInfo || {};
  const name = corporateUserInformation.firstName;

  return (
    <HorizontalList
      items={[...(isLargeOrXlarge ? getCustomerInfoItems() : []), ...getActionItems()]}
      {...getCommonListProps()}
    />
  );

  function getCommonListProps() {
    return {
      light,
      spacing: "small",
    };
  }

  function getCustomerInfoItems() {
    const items = [];
    const availablePoints = companyInformation?.rewardsSummary?.totalAvailablePoints;
    const companyId = companyInformation?.companyId;

    name &&
      items.push({
        componentProps: {
          children: (
            <span {...getItemWrapperProps(styles.greeting)}>
              {i18n("DesktopHeaderControl__GREETING", { name: convertToTitleCase(name) })}
            </span>
          ),
          emphasis: false,
        },
        tagName: "span",
      });
    availablePoints &&
      items.push({
        componentProps: {
          children: (
            <span {...getItemWrapperProps()}>
              <Currency {...getCurrencyProps(availablePoints)} />
            </span>
          ),
          emphasis: false,
        },
        tagName: "span",
      });
    companyId &&
      items.push({
        componentProps: {
          children: (
            <span {...getItemWrapperProps()}>
              {i18n("CtmInformation__SWABIZ")} {companyId}
            </span>
          ),
          emphasis: false,
        },
        tagName: "span",
      });

    return items;
  }

  function getActionItems() {
    const items = [];

    isLargeOrXlarge &&
      items.push({
        componentProps: {
          children: i18n("CtmInformation__TRAVEL_MANAGER_ACCOUNT"),
          href: CORPORATE__TRAVEL_MANAGER_ACCOUNT_MANAGEMENT,
          size: "fontSize13",
        },
      });
    items.push({
      componentProps: {
        children: i18n("DesktopHeaderControl__LOG_OUT"),
        onClick: handleLogout,
        size: "fontSize13",
      },
    });

    return items;
  }

  function getItemWrapperProps(className) {
    return {
      className: classNames(styles.itemWithSeparator, className),
    };
  }

  function getCurrencyProps(value) {
    return {
      amount: value,
      currencyCode: "POINTS",
    };
  }
};

CtmInformation.displayName = "CtmInformation";
CtmInformation.propTypes = {
  /** Indicates whether the app is using a dark Header background, to be passed to Link component for styling. */
  light: PropTypes.bool,
};
